export const dataHooks = {
    messageBoxFunctionalLayoutCount: 'messageBoxFunctionalLayout-count',
    messageBoxFunctionalLayoutButton: 'messageBoxFunctionalLayout-button',
    content: 'message-box-body',
    header: 'header-layout',
    headerTitle: 'header-layout-title',
    headerCloseButton: 'header-close-button',
    footer: 'message-box-footer',
    footerCancelButton: 'cancellation-button',
    footerConfirmButton: 'confirmation-button',
    footerBelowChildren: 'footer-layout-bottom-children',
};
//# sourceMappingURL=constants.js.map